import { render } from "./PageNumberIcon.vue?vue&type=template&id=d9892b6a"
const script = {}
script.render = render

export default script